export default __webpack_public_path__ + "static/image-6-mob-688ed1ff096982cddd96d43b7a197e5e.jpg";